import React from 'react'
import PropTypes from 'prop-types'
import parseGGDriver from '../../../helpers/parseGGDriver'

class DesignSleevesCol extends React.PureComponent {

    render() {
        const {designSleeves, productStatus, item} = this.props
        const {designSleeveLeft, designSleeveRight} = {...item}
        const _designSleeves = parseGGDriver(designSleeves || '')
        const displayField = productStatus !== 'cancelled' ? 'notDisableCancel DesignSleeves' : 'DesignSleeves'
        const sleeveNumber = designSleeveLeft && designSleeveRight ? 2 : designSleeveLeft || designSleeveRight ? 1 : 0

        return (
            <div className={displayField}>
                {!!(designSleeveLeft || designSleeveRight) &&
                    <a href={_designSleeves} target='_blank' rel='noopener noreferrer'>
                        <u>S</u>leeve<br />
                        {sleeveNumber ? `${sleeveNumber} TAY ÁO` : 'TAY ÁO'}
                    </a>
                }
            </div>
        )
    }
}

DesignSleevesCol.propTypes = {
    productStatus:PropTypes.string,
    designSleeves: PropTypes.string,
}

export default DesignSleevesCol
